export default __webpack_public_path__ + "static/media/BeginConnecting.9ccbd37f.png";